import dayjs, { Dayjs } from "dayjs";

export const formatAmount = (amount: any) => {
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const addOrUpdateItem = (item: any, items: any[]) => {
  var index = items.findIndex(
    (a) =>
      // eslint-disable-next-line eqeqeq
      a.beneficiary_service_request_id == item.beneficiary_service_request_id
  );

  if (index !== -1) {
    items[index] = item;
  } else {
    items.push(item);
  }
  return items;
};

export const removeItem = (item: any, items: any[]) => {
  var index = items.findIndex(
    (a) =>
      // eslint-disable-next-line eqeqeq
      a.beneficiary_service_request_id == item.beneficiary_service_request_id
  );
  return items.filter((_, i) => i !== index);
};

export const sponsorshipType = [
  { id: "main", name: "رئيسية" },
  { id: "support", name: "دعم" },
  { id: "widow", name: "أرملة" },
  { id: "main_support", name: "رئيسية و دعم" },
];
export const switchOptions = (beneficiaryType: any) => {
  if (Array.isArray(beneficiaryType)) {
    if (
      beneficiaryType.includes("mother") &&
      beneficiaryType.includes("son") &&
      beneficiaryType.includes("daughter")
    ) {
      return sponsorshipType; 
    } else if (beneficiaryType.includes("son") || beneficiaryType.includes("daughter")) {
      return [
        { id: "main", name: "رئيسية" },
        { id: "support", name: "دعم" },
        { id: "main_support", name: "رئيسية و دعم" },
      ]; // يتيم(ة)
    }
  }

  if (beneficiaryType === "mother") {
    return [{ id: "widow", name: "أرملة" }];
  }

  return sponsorshipType;
};
export const switchType = (item: any) => {
  switch (item) {
    case "كفالة دعم":
      return "support";
    case "كفالة أرملة":
      return "widow";
    case "كفالة رئيسية":
      return "main";
    case "كفالة رئيسية و دعم":
      return "main_support";
  }
};
export const customFilter = (input: any, elems: any, fields: any) => {
  if (input.length === 0) {
    return elems;
  }
  input = escapeRegExp(input);
  var words = input.split(" ");
  var regexs = [];
  for (var i = 0; i < words.length; i++) {
    var l__without = words[i];
    l__without = l__without.replace("è", "e");
    regexs.push(new RegExp(".*" + l__without + ".*", "i"));
  }
  var matchs = [];
  for (i = 0; i < elems.length; i++) {
    var toSearch = "";
    for (var j = 0; j < fields.length; j++) {
      if (elems[i][fields[j]]) {
        toSearch += elems[i][fields[j]];
      }

      if (j < fields.length - 1) {
        toSearch += " ";
      }
    }
    var match = true;
    for (j = 0; j < regexs.length; j++) {
      l__without = toSearch;
      l__without = l__without.replace("è", "e");
      if (!regexs[j].exec(l__without)) {
        match = false;
      }
    }
    if (match) {
      matchs.push(elems[i]);
    }
  }

  return matchs;
};

const escapeRegExp = (str: any) => {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, " ");
};
export const isRoleSponsor = (role: string) =>
  [
    "sponsor",
    "sponsor_participant",
    "sponsor_endower",
    "sponsor_endower_participant",
  ].includes(role);
export const isRoleEndower = (role: string) =>
  ["endower", "endower_participant", "donor", "participant"].includes(role);
export const getTargeted = (role: string) => {
  switch (role) {
    case "beneficiary":
      return ["beneficiaries"];
    case "sponsor":
      return ["sponsors"];
    case "endower":
      return ["endowers"];
    case "endower_participant":
      return ["endowers", "participant"];
    case "donor":
      return ["donors"];
    case "participant":
      return ["participants"];
    case "sponsor_participant":
      return ["participants", "sponsors"];
    case "sponsor_endower":
      return ["endowers", "sponsors"];
    case "sponsor_endower_participant":
      return ["endowers", "sponsors", "participants"];
  }
};
export const handleBookingLines = (selectedItems: any[]) => {
  return selectedItems?.map((item: any) => ({
    partner_id: item.id,
    sponsorship_type: switchType(
      item.selectedSponsorShipType?.label
        ? item.selectedSponsorShipType.label
        : item.selectedSponsorShipType
    ),
    month_number: item.month.toString(),
    sponsorship_start_date: item.sponsorship_start_date.format("YYYY-MM-DD"),
  }));
};
export const disabledDate = (current: Dayjs | null): boolean => {
  if (!current) return false;

  const today = dayjs();
  const isNotFirstDay = current.date() !== 1;
  const isPastMonth = current.isBefore(today.startOf("month"), "month");

  return isNotFirstDay || isPastMonth;
};
export const calculateDefaultDate = () => {
  const today = dayjs();
  const currentDay = today.date();
  if (currentDay <= 15) {
    return today.startOf("month");
  }
  return today.add(1, "month").startOf("month");
};
export const disabledDateCancel = (current: Dayjs | null): boolean => {
  if (!current) return false;

  const today = dayjs();
  const isNotFirstDay = current.date() !== 1;
  const nextMonthStart = today.add(1, "month").startOf("month");

  const isPastMonth = current.isBefore(nextMonthStart, "month");
  const isthisMonth = current.isBefore(today.startOf("month"), "month");

  if (today.date() >15){
  return isNotFirstDay || isPastMonth;
}
else {
  return isNotFirstDay || isthisMonth;
}
};
export const allowOnlyFirstDay = (current: Dayjs | null): boolean => {
  if (!current) return false;
  return current.date() !== 1;
};